import planTypeById from "../../../../constants/planTypeById.json";
import productResource from "../../../billing/resources/productResource";
import SubscriptionResource from "../../../billing/resources/subscriptionResource";
import {mapGetters, mapActions} from 'vuex'

const PREMIUM_PLAN_ID = '57568'
const PAUSED_PLAN_ID = '63352'
const BUSINESS_PLAN_ID = '57346'


export default {
  data() {
    return {
      premiumPlanCreditsAmount: 3,
      creditsToAdd: 3,
      upgradeInProgress: false,
      showConfirmUnpauseSubscription: false
    }
  },
  methods: {
    ...mapActions([
      'setPlanPrices',
    ]),
    openConfirmPauseSubscription() {
      this.showConfirmUnpauseSubscription = true
    },
    closeConfirmUnpauseSubscription() {
      this.showConfirmUnpauseSubscription = false
    },
    async upgradeSubscription(quantityToAdd) {
      this.upgradeInProgress = true
      this.subscription = (await SubscriptionResource.upgradeSubscription(
        PREMIUM_PLAN_ID, this.currentPremiumPlanQuantity + quantityToAdd)).subscription
      this.upgradeInProgress = false
    },
    async unpauseSubscription() {
      this.upgradeInProgress = true
      this.subscription = (await SubscriptionResource.unpauseSubscription()).subscription
      this.upgradeInProgress = false
    },
    async pauseSubscription () {
      this.subscription = (await SubscriptionResource.pauseSubscription()).subscription
      this.$toasted.show(`Subscription has been paused`, {duration: 3000, type: 'success'})
      this.$router.push({name: 'Billing'})
    },
    async cancelSubscription () {
      this.subscription = (await SubscriptionResource.cancelSubscription()).subscription
      this.$toasted.show(`Subscription has been cancelled`, {duration: 3000, type: 'success'})
      this.$router.push({name: 'Billing'})
    },
    async initPlanPrices () {
      let [premiumPlanPrice, pausedPlanPrice] = await Promise.all([PREMIUM_PLAN_ID, PAUSED_PLAN_ID].map(planID => {
        return getProductPrice(planID)
      }))

      this.setPlanPrices({
        [PREMIUM_PLAN_ID]: premiumPlanPrice,
        [PAUSED_PLAN_ID]: pausedPlanPrice
      })

      async function getProductPrice(productId) {
        return (await productResource.getProductPrice(productId)).price
      }
    }
  },
  computed: {
    ...mapGetters(['planPrices']),
    premiumPlanPrice() {
      return this.planPrices[PREMIUM_PLAN_ID]
    },
    pausedPlanPrice() {
      return this.planPrices[PAUSED_PLAN_ID]
    },
    subscription() {
      return this.$store.getters.subscription
    },
    planNameBeforePause() {
      return planTypeById[this.subscription.planBeforePause]
    },
    currentPremiumPlanQuantity() {
      return this.subscription.plan.id === PREMIUM_PLAN_ID ? this.subscription.quantity : 0
    },
    currentPlan() {
      return this.subscription.plan
    },
    planQuantityToAdd() {
      return this.creditsToAdd / this.premiumPlanCreditsAmount
    },
    subscriptionPaused() {
      return this.subscription.plan._id === PAUSED_PLAN_ID
    },
  }
}

